import { Typography } from "@mui/material";
import { NoPermission } from "app/components/NoPermission";
import React from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { selectFeaturePermissions } from "store/global/authPermission/selector";
import { PermissionFeature } from "store/global/authPermission/types";
import { useStyles } from "./styles";

const Notification = () => {
  const { t } = useTranslation();
  const styles = useStyles();
  const featurePermissions = useSelector(selectFeaturePermissions);
  const { hasNoAccess } =
    featurePermissions[PermissionFeature.PUSH_NOTIFICATION];

  if (hasNoAccess) {
    return (
      <div className={styles.mainContainer}>
        <NoPermission />
      </div>
    );
  }

  return (
    <div className={styles.mainContainer}>
      <div className={styles.root}>
        <Typography variant="h4">{t("SIDEBAR.PUSH_NOTIFICATION")}</Typography>
      </div>
    </div>
  );
};

export default Notification;
